export default __webpack_public_path__ + "static/media/team9.4fbc60c7.png";